import { flattenObj } from "@/utils/lodash";

const sorted = {
  date_created: -1,
};

const newsKeys = {
  all: [{ scope: "newsArticles", limit: 100, sorted }],
  count: (options: any, locale = "vi") => [
    {
      scope: "newsArticles",
      type: "count",
      sorted,
      ...flattenObj(options || {}),
    },
  ],
  list: (options: any, locale = "vi") => [
    {
      scope: "newsArticles",
      type: "list",
      sorted,
      ...flattenObj(options || {}),
    },
  ],
  first: () => [
    {
      scope: "newsArticles",
      type: "list",
      sorted,
    },
  ],
  detail: (slug: string, locale = "vi") => [
    { scope: "newsArticles", type: "detail", slug, locale },
  ],
};

export default newsKeys;
